import {EditProjectPatientValidationSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

interface EditProjectPatientFormProviderProps {
    defaultValues: EditProjectPatientValidationSchema
    children: ReactNode
}

export const EditProjectPatientFormProvider = ({defaultValues, children}: EditProjectPatientFormProviderProps) => {
    const form = useForm<EditProjectPatientValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(EditProjectPatientValidationSchema),
        defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
